<template>
  <div class="modal" :id='modalId' tabindex="-1" aria-labelledby="thisModalLabel" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog" :class="modalClass">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
           <div class="text-dark text-center" v-if="okRunning">
            {{ processingMessage }}
            <pulse-loader color="black"></pulse-loader>
          </div>
          <slot v-else name="modal-content">
              Modal Content goes here
          </slot>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="closeFunction"
            data-bs-dismiss="modal"
            v-if="buttons.includes('C')">
            {{ closeText || 'Close '}}
          </button>
          <button type="button" class="btn btn-primary" @click="okFunction" v-if="buttons.includes('O')" :disabled="okDisabled">{{ okText || 'Ok' }}</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="js">
import { defineComponent, watch, ref, onMounted, computed } from "@vue/composition-api";
import PulseLoader from 'vue-spinner/src/PulseLoader'
import { Modal } from 'bootstrap';

export default defineComponent({
  components: {
    PulseLoader
  },
  props: {
      value: Boolean,
      title: String,
      okText: {
        type: String,
        required: false
      },
      closeText: String,
      okCallback: Function,
      processingMessage: {type: String, default: 'Processing...'},
      closeCallback: Function,
      modalClass: String,
      buttons: { type: String, default: 'CO' },
      disableOk: Boolean,
      modalId: {
        type: String,
        default: 'thisModal'
      }
  },
  setup(props, {emit}) {
      let modal = null
      const okRunning = ref(false);
      const okDisabled = computed(() => {
        return props.disableOk || okRunning.value;
      })
      
      onMounted(()=>{
          const el = document.getElementById(props.modalId);
          modal = new Modal(el)

          el.addEventListener('hide.bs.modal', function (event) {
            emit('input', false)
          })

          if (props.value) {
            modal.show();
          }
      })

      watch (()=>props.value, (newVal, oldVal) => {
          //console.log(`new value: ${newVal} `)
          if (modal) {
            if (newVal)
              modal.show();
            else
              modal.hide();
          }
      })

        const closeFunction = () => {
            //alert('close')
            emit('input', false)
        }
        const okFunction = async () => {
          if(okRunning.value == false){
            okRunning.value = true;
            let result = false;
            if (typeof(props.okCallback) ==='function') {
              result = await props.okCallback()
            }
            if (result) {
              emit('input', false)
            }
            okRunning.value = false;
          }
        }
    return {
        okFunction,
        closeFunction,
        okDisabled,
        okRunning
    };
  }
});
</script>